var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gdialogs-container"},_vm._l((_vm.dialogs),function(item,index){return _c('GDialog',{key:'dialog_' + index,attrs:{"item":item},on:{"close":_vm.closeDialog}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }